var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"m-card"},[(_vm.hasHeader)?_c('header',{class:_vm.headerClass},[_vm._t("header")],2):_vm._e(),_c('main',{class:_vm.mainClass},[_vm._t("default")],2),(_vm.hasFooter)?_c('footer',[_vm._t("footer")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }